import { render } from "./StudentRegister.vue?vue&type=template&id=9bf8bf6e&scoped=true"
import script from "./StudentRegister.vue?vue&type=script&lang=js"
export * from "./StudentRegister.vue?vue&type=script&lang=js"

import "./StudentRegister.vue?vue&type=style&index=0&id=9bf8bf6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bf8bf6e"]])

export default __exports__